import {Enum} from "~/enums/index";

export default new Enum({
    NONE: "NONE",
    LIMITED: "LIMITED",
    LIMITED_CROSS_TYPES: "LIMITED_CROSS_TYPES",
    FULL: "FULL",
    FULL_CROSS_TYPES: "FULL_CROSS_TYPES",
});
